import SplitTest from '../models/split_test';

export default {
  name: 'splitTests',

  getReducer: () => {
    const initialData = {
      data: null,
      loading: false,
    };

    return (state = initialData, { type, payload }) => {
      if (type === 'FETCH_SPLIT_TESTS_START') {
        return { ...state, loading: true };
      }
      if (type === 'FETCH_SPLIT_TESTS_SUCCESS') {
        return { ...state, loading: false, data: payload.results };
      }
      if (type === 'FETCH_SPLIT_TESTS_ERROR') {
        return { ...state, loading: false };
      }
      return state;
    };
  },

  doFetchSplitTests:
    () =>
    async ({ dispatch, getState, store }) => {
      const authenticatedUser = store.selectAuthenticatedUser(getState());
      if (
        !authenticatedUser ||
        !authenticatedUser.isAuthorized('ui.split.test')
      ) {
        return;
      }

      dispatch({ type: 'FETCH_SPLIT_TESTS_START' });
      try {
        const response = await SplitTest.order({ name: 'asc' }).all();
        dispatch({
          type: 'FETCH_SPLIT_TESTS_SUCCESS',
          payload: { results: response.data },
        });
      } catch (error) {
        console.error('Failed to fetch split tests:', error);
        dispatch({ type: 'FETCH_SPLIT_TESTS_ERROR' });
      }
    },

  selectSplitTestData: state => state.splitTests.data || [],
  selectSplitTestLoading: state => state.splitTests.loading,
  selectActiveSplitTests: state =>
    (state.splitTests.data || []).filter(st => st.active),
  selectInactiveSplitTests: state =>
    (state.splitTests.data || []).filter(st => !st.active),
};
